//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
import "../CAM/CAM.CustomParameterDataSetList.js";
import "../CAM/CAM.Notes.js";
let d=[[[1,"CustomParameterSetListBuilder",0,"CAM.CustomParameterDataSetList",0],[0,"FeedRate",1,0],[0,"FeedType",1,0],[0,"FeedUnit",1,0],[0,"MotionType",1,0],[1,"Notes",0,"CAM.Notes",0],[0,"NumberOfUserParameters",0,0],[0,"ProtectedMove",1,0],[0,"SubopLabel",1,0]],[[["parent"],"SetParent",{},1,0],[["sibling"],"SetSibling",{},1,0],[["parameterName"],"GetUserParameter",{R_:{parameter:"CAM.UdeParameter"}},1,0],[["index"],"GetUserParameter1",{R_:{parameter:"CAM.UdeParameter"}},1,0]],[]];
SPLM.CAM.MoveBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.MoveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.MoveBuilder.Motion = Object.freeze({
    "Rapid" : "Rapid", "Engage" : "Engage", "Cut" : "Cut", "Stepover" : "Stepover", "Retract" : "Retract", "Approach" : "Approach", "Traversal" : "Traversal", "Departure" : "Departure", "Return" : "Return", "FirstCut" : "FirstCut", "LastCut" : "LastCut", "Crossover" : "Crossover"});

SPLM.CAM.MoveBuilder.Feed = Object.freeze({
    "Motion" : "Motion", "Custom" : "Custom"});

export default SPLM;